import { Injectable } from '@angular/core';
import { ActivityStudentAnswers, Answers, StudentMultiAnswers } from '@tekman/onmat/models';

@Injectable({
  providedIn: 'root',
})
export class RadioButtonsService {
  private activityAnswers: Answers[] = [];

  parseRadioButton(
    htmlStatement: string,
    isTeacher: boolean,
    answers: Answers[],
    studentAnswers: ActivityStudentAnswers,
    isValidated: boolean,
    isSent: boolean
  ): string {
    if (Array.isArray(answers) && answers.length > 0) {
      this.activityAnswers = answers;
      let checked: boolean;
      const isDisabled = isTeacher ? true : isValidated;
      if (isTeacher) {
        this.activityAnswers.forEach(answer => {
          if (studentAnswers) {
            studentAnswers.multipleAnswers.forEach(studentAnswer => {
              if (answer.id === studentAnswer.answerId) {
                checked = studentAnswer.selected && isSent;
                answer = { ...answer, isCorrect: studentAnswers.isMultipleAnswerSelectionCorrect };
              }
            });
          }
          // remove style attribute pero lo mejor sería no ponerlo en el html desde el principio des de la api
          const context = answer?.text.replace(/'/g, '&#39;').replace(/style\s*=\s*["'][^"']*["']/g, '');
          htmlStatement += `<tekman-math><radio-buttons labelText='${context}'
        [checked]="${checked}" [isCorrect]="${answer.isCorrect}" controlName="tekradio" id="${answer.id}"
        [validated]="${isValidated}" [disabled]="${isDisabled}" [teacherSolution]="${answer.isCorrect}"
        ></radio-buttons></tekman-math>`;
        });
      } else if (Array.isArray(studentAnswers?.multipleAnswers) && studentAnswers?.multipleAnswers?.length > 0) {
        answers = this.sortAnswers(answers, studentAnswers.multipleAnswers);
        answers.forEach(answer => {
          studentAnswers.multipleAnswers.forEach(studentAnswer => {
            if (answer.id === studentAnswer.answerId) {
              checked = studentAnswer.selected;
              answer.isCorrect = studentAnswers.isMultipleAnswerSelectionCorrect;
            }
          });
          // remove style attribute pero lo mejor sería no ponerlo en el html desde el principio des de la api
          const context = answer?.text.replace(/'/g, '&#39;').replace(/style\s*=\s*["'][^"']*["']/g, '');
          htmlStatement += `<tekman-math><radio-buttons labelText='${context}'
        [checked]="${checked}" [isCorrect]="${answer.isCorrect}" controlName="tekradio" id="${answer?.id}"
        [validated]="${isValidated || studentAnswers?.sentAt !== null}" [disabled]="${
            isDisabled || studentAnswers?.sentAt !== null
          }"></radio-buttons></tekman-math>`;
        });
      }
    }
    return htmlStatement;
  }

  private sortAnswers(answers: Answers[], studentMultipleAnswers: StudentMultiAnswers[]): Answers[] {
    return answers
      .map(answer => {
        studentMultipleAnswers.forEach(studentAnswer => {
          if (answer.id === studentAnswer.answerId) {
            answer = { ...answer, order: studentAnswer.order };
          }
        });
        return answer;
      })
      .sort((a, b) => a.order - b.order);
  }
}
